import { sharedPathes } from '@/shahrzad-assets/shared-routing/pathe'
import { icons } from '@/shahrzad-assets/shared-asstes/icons'
import { colors } from '@/shahrzad-assets/shared-constants/colors'
import { dimens } from '@/shahrzad-assets/shared-constants/dimens'
import { fontSize, fontsWeight } from '@/shahrzad-assets/shared-constants/fonts'
import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { Breakpoint } from 'react-socks'
import { styled } from 'styled-components'
import { HomeContext } from '@/shahrzad-assets/shared-contexts/HomeContext'

const WalletChargeSmallUp = () => {
  const { balance } = useContext(HomeContext)

  return (
    <Breakpoint large up>
      <WalletContainer
        onClick={() =>
          (window.location.href =
            import.meta.env.VITE_MAIN_WEB_URL + sharedPathes.WALLET)
        }
      >
        <Right>
          <img src={icons.WALLET_BLACK} />
          <span>کیف پول:</span>
        </Right>

        <Left>
          <Balance>{balance?.toLocaleString()}&nbsp;</Balance>
          <span>ریال</span>
        </Left>
      </WalletContainer>
    </Breakpoint>
  )
}

export default WalletChargeSmallUp

const WalletContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${dimens.SPACING_XS} ${dimens.SPACING_S};
  border: 1px solid ${colors.stroke2};
  border-radius: ${dimens.BORDER_RADIUS_8};
  background-color: ${colors.WHITE};
  cursor: pointer;
`

const Right = styled.div`
  display: flex;
  align-items: center;
  font-size: ${fontSize.SMALL};
  img {
    margin-left: ${dimens.SPACING_XXS_NUDGE};
  }
  span {
    font-size: ${fontSize.MEDIUM};
    font-weight: ${fontsWeight.MEDIUM};
  }
`

const Left = styled.div`
  display: flex;
  align-items: center;
  font-size: ${fontSize.SMALL};
  padding: 0 ${dimens.SPACING_XS};
`

const Balance = styled.span`
  font-size: ${fontSize.EXTRA_LARGE};
  font-weight: ${fontsWeight.BOLD};
`
